// extracted by mini-css-extract-plugin
export default {"container":"Icon_container__Z+-+h","clickable":"Icon_clickable__4W4KA"};